import { render, staticRenderFns } from "./Creditfreeinfo.vue?vue&type=template&id=2bac43fb&"
import script from "./Creditfreeinfo.vue?vue&type=script&lang=js&"
export * from "./Creditfreeinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports